import { differenceInSeconds } from 'date-fns';
import axios from 'axios';
import { useState, useEffect, useCallback } from 'react';


export const use_core_serial = (hsInfo) => {
  if (!hsInfo) return false;

  let label = hsInfo["label"] || "";

  if (label.startsWith("HB0") && hsInfo.os_vsn >= "0_1_69") {
    return false;
  }

  if (label.startsWith("HB11")) {
    const ble_vsn = hsInfo.app_vsn?.ble;
    if (ble_vsn && ble_vsn >= "1.69.109") {
      return false;
    }
  }

  return true;
  //return Boolean(hsInfo.extra?.device?.last_serial);
};



// ===============================================================================================================
// ===============================================================================================================
// ===============================================================================================================



export const convertHexToRGB = (hex) => {
  // check if it's a rgba
  if (hex.match('rgba')) {
    let triplet = hex.slice(5).split(',').slice(0, -1).join(',');
    return triplet;
  }

  let c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('');
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = '0x' + c.join('');

    return [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',');
  }
};

export function debounce(func, wait, immediate) {
  console.log("debounce.ogre");
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      timeout = null;
      if (!immediate) {
        console.log("debounce.ogre", "timed api");
        func.apply(context, args);
      }
    }, wait);
    if (immediate && !timeout) {
      console.log("debounce.ogre", "untimed api");
      func.apply(context, args);
    }
  };
}

export const debounce_simple = (func, delay) => {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => func(...args), delay);
  };
};


export function isMobile() {
  if (window) return window.matchMedia(`(max-width: 767px)`).matches;

  return false;
}

export function isMdScreen() {
  if (window) return window.matchMedia(`(max-width: 1199px)`).matches;

  return false;
}

function currentYPosition(elm) {
  if (!window && !elm) {
    return;
  }
  if (elm) return elm.scrollTop;
  // Firefox, Chrome, Opera, Safari
  if (window.pageYOffset) return window.pageYOffset;
  // Internet Explorer 6 - standards mode
  if (document.documentElement && document.documentElement.scrollTop)
    return document.documentElement.scrollTop;
  // Internet Explorer 6, 7 and 8
  if (document.body.scrollTop) return document.body.scrollTop;
  return 0;
}

function elmYPosition(elm) {
  var y = elm.offsetTop;
  var node = elm;
  while (node.offsetParent && node.offsetParent !== document.body) {
    node = node.offsetParent;
    y += node.offsetTop;
  }
  return y;
}

export function scrollTo(scrollableElement, elmID) {
  var elm = document.getElementById(elmID);

  if (!elmID || !elm) {
    return;
  }

  var startY = currentYPosition(scrollableElement);
  var stopY = elmYPosition(elm);

  var distance = stopY > startY ? stopY - startY : startY - stopY;
  if (distance < 100) {
    scrollTo(0, stopY);
    return;
  }
  var speed = Math.round(distance / 50);
  if (speed >= 20) speed = 20;
  var step = Math.round(distance / 25);
  var leapY = stopY > startY ? startY + step : startY - step;
  var timer = 0;
  if (stopY > startY) {
    for (var i = startY; i < stopY; i += step) {
      setTimeout(
        (function (leapY) {
          return () => {
            scrollableElement.scrollTo(0, leapY);
          };
        })(leapY),
        timer * speed
      );
      leapY += step;
      if (leapY > stopY) leapY = stopY;
      timer++;
    }
    return;
  }
  for (let i = startY; i > stopY; i -= step) {
    setTimeout(
      (function (leapY) {
        return () => {
          scrollableElement.scrollTo(0, leapY);
        };
      })(leapY),
      timer * speed
    );
    leapY -= step;
    if (leapY < stopY) leapY = stopY;
    timer++;
  }
  return false;
}



// ===============================================================================================================
// ===============================================================================================================
// ===============================================================================================================



function convertUTCDateToLocalDate(date) {
  var newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
  return newDate;
}

function getDeltaMinutes(gmtTimestamp, now) {  //Date.now()
  var localDate = convertUTCDateToLocalDate(new Date(gmtTimestamp));
  var local_epoch = localDate.valueOf();  // milliseconds
  var local_delta = now.now() - local_epoch;   // Date.now() = milliseconds

  var minutes = local_delta / 1000 / 60;
  return minutes;
}

export function getDeltaTime(theTime, now) {
  try {

    let delta = now.getTime() - theTime.getTime();
    var hours = delta / 1000 / 60 / 60;
    var days = Math.floor(hours / 24);
    hours = hours - (24 * days);
    var time_delta = "";
    if (days == 0) {
      if (hours < 1.0) {
        var minutes = delta / 1000 / 60;
        if (minutes.toFixed(0) == "1") {
          time_delta = "1 minute";
        } else {
          time_delta = minutes.toFixed(0) + " minutes";
        }
      } else {
        time_delta = hours.toFixed(1) + " hours";
      }
    } else {
      time_delta = days.toFixed(0) + " days " + hours.toFixed(0) + " hours";
      if (hours.toFixed(0) == "1")
        time_delta = time_delta.replace("hours", "hour");
    }

    return { timeString: time_delta, deltaSeconds: delta / 1000 };

  } catch (e) {
    return "";
  }
}

export function formatTime(ts_in) {
  try {
    if (ts_in == undefined)
      return "";

    let theTime = new Date(ts_in);

    let now = new Date();
    let yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);

    let yyyy = theTime.getFullYear();
    let mm = (1 + theTime.getMonth()).toString().padStart(2, '0');
    let dd = theTime.getDate().toString().padStart(2, '0');

    let t_yyyy = now.getFullYear();
    let t_mm = (1 + now.getMonth()).toString().padStart(2, '0');
    let t_dd = now.getDate().toString().padStart(2, '0');

    let y_yyyy = yesterday.getFullYear();
    let y_mm = (1 + yesterday.getMonth()).toString().padStart(2, '0');
    let y_dd = yesterday.getDate().toString().padStart(2, '0');

    let day = "";
    if (yyyy == t_yyyy && mm == t_mm && dd == t_dd) {
      day = "Today";
    } else if (yyyy == y_yyyy && mm == y_mm && dd == y_dd) {
      day = "Yesterday";
    } else {
      day = mm + "/" + dd;
    }
    let deltaTimes = getDeltaTime(theTime, now);
    try {
      return {
        timeString: deltaTimes.timeString + " ago -  " + day + " " + theTime.toLocaleTimeString(),
        deltaSeconds: deltaTimes.deltaSeconds
      };
    } catch (e) {
      console.log(e);
    }
    return {
      timeString: 'unknown',
      deltaSeconds: 0
    };

    //return theTime.toISOString();
  } catch (e) {
    console.log(e);
  }
  return { timeString: ts_in, deltaSeconds: 9999999 };
}

export function formatTime2(ts_in) {
  if (ts_in) {
    let { timeString, deltaSeconds } = formatTime(ts_in);
    return timeString;
  }
  return "";
}

export function getTimeDifference(date) {
  let difference = differenceInSeconds(new Date(), date);

  if (difference < 60) return `${Math.floor(difference)} sec`;
  else if (difference < 3600) return `${Math.floor(difference / 60)} min`;
  else if (difference < 86400) return `${Math.floor(difference / 3660)} h`;
  else if (difference < 86400 * 30) return `${Math.floor(difference / 86400)} d`;
  else if (difference < 86400 * 30 * 12) return `${Math.floor(difference / 86400 / 30)} mon`;
  else return `${(difference / 86400 / 30 / 12).toFixed(1)} y`;
}

export function sleep(delay = 0) {
  return new Promise((resolve) => setTimeout(resolve, delay));
}
//await sleep(3000); // For demo purposes.

export function adjustColor(color, amount) {
  return '#' + color.replace(/^#/, '').replace(/../g, color => ('0' + Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)).substr(-2));
}

export function getEnvironment(hsInfo) {

  //return hsInfo["environment"] || "";
  let environment = "";
  if (hsInfo && "environment" in hsInfo) {
    environment = hsInfo["environment"]
  }

  return environment;

}

export function wsUrl() {

  //return "ws://mdm.armware.com:3001/apiws/";

  //console.log("apiUrl.moose process.env.REACT_APP_WS_URL=", process.env.REACT_APP_API_URL);
  console.log("apiUrl.moose socket wsUrl=", window.location.origin.replace(":3000", ":3001").replace(/^http/, "ws") + "/apiws/");
  return window.location.origin.replace(":3000", ":3001").replace(/^http/, "ws") + "/apiws/";

  return "wss://dev.supportal.rcp.care/apiws/";

  // This variable is set in the EKS deployment and read by the Node.js process.
  // Fallback to a local default if the variable is not set.
  return process.env.REACT_APP_WS_URL || "ws://xxx.mdm.armware.com:3001/apiws/";
}

export function apiUrl(path) {
  console.log("apiUrl.moxie process.env.REACT_APP_API_URL=", process.env.REACT_APP_API_URL);
  console.log("apiUrl.moxie origin=", window.location.origin);
  console.log("apiUrl.moxie window._env_=", window._env_);

  return window.location.origin.replace(":3000", ":3001") + path;

  //return "https://dev.supportal.rcp.care" + path;

  // This variable is set in the EKS deployment and read by the Node.js process.
  // Fallback to a local default if the variable is not set.
  const baseUrl = process.env.REACT_APP_API_URL || 'http://xxx.mdm.armware.com:3001'; // 'http://localhost:3001';
  return `${baseUrl}${path}`;
}

export function eduUrl(path) {

  return window.location.origin.replace(":3000", ":3002") + path;

  return "https://dev.edu.rcp.care" + path;

  // This variable is set in the EKS deployment and read by the Node.js process.
  // Fallback to a local default if the variable is not set.
  const baseUrl = process.env.REACT_APP_EDU_URL || 'http://xxx.mdm.armware.com:3002'; //'http://localhost:3002';
  return `${baseUrl}${path}`;
}

export const hubsupportalApi = axios.create({
  baseURL: apiUrl("/api/"), // "http://localhost:3000/api/",
  headers: {
    "Content-type": "application/json",
  },
  withCredentials: true,
  timeout: 90000, // 90 seconds timeout
});

// ===============================================================================================================
// Global error guard
// ===============================================================================================================
// If any code forgets to wrap/await/catch an API call, the browser can show the CRA runtime error overlay
// on unhandled Promise rejections (e.g. 500s).
// We defensively swallow *unhandled* axios errors and log them instead.
// NOTE: Well-behaved pages should still catch and render user-friendly UI.
if (typeof window !== 'undefined' && !window.__HS_UNHANDLED_REJECTION_GUARD__) {
  window.__HS_UNHANDLED_REJECTION_GUARD__ = true;

  window.addEventListener('unhandledrejection', (event) => {
    try {
      const reason = event?.reason;
      if (!reason) return;

      // Axios cancellations (AbortController, navigation aborts, explicit cancel)
      const isCanceled =
        axios.isCancel?.(reason) ||
        reason?.code === 'ERR_CANCELED' ||
        reason?.name === 'CanceledError' ||
        reason?.message === 'canceled';

      // Axios HTTP errors (500s, 4xx, etc.)
      const isAxiosError =
        reason?.isAxiosError === true ||
        (typeof reason?.message === 'string' && reason.message.includes('Request failed with status code'));

      // We only swallow errors that we know come from Axios requests.
      // (We don't want to hide real coding errors.)
      if (isCanceled || isAxiosError) {
        console.error(
          'Unhandled Axios rejection (swallowed to prevent runtime overlay):',
          reason
        );
        // Prevent the default browser/CRA overlay behavior for this unhandled rejection.
        event.preventDefault();
      }
    } catch (_e) {
      // no-op
    }
  });
}

export const educationApi = axios.create({
  baseURL: eduUrl("/api/"),
  headers: {
    "Content-type": "application/json",
  },
  withCredentials: true,
  timeout: 90000,
});

// Add interceptors directly, do NOT copy handlers from hubsupportalApi
educationApi.interceptors.request.use(
  async (config) => {
    console.log("educationApi.ogre", config.url);
    const access_token = localStorage.getItem("access_token");
    if (access_token) {
      config.headers["Authorization"] = `Bearer ${access_token}`;
      config.headers["x-access-token"] = `${access_token}`;
    }
    const refresh_token = localStorage.getItem("refresh_token");
    if (refresh_token) {
      config.headers["x-refresh-token"] = `${refresh_token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

educationApi.interceptors.response.use(
  (response) => response,
  async function (error) {
    // You can reuse the same logic as hubsupportalApi here if needed
    return Promise.reject(error);
  }
);

// Store the original get and post methods
const originalGet = hubsupportalApi.get;
const originalPost = hubsupportalApi.post;
const originalEducationGet = educationApi.get;
const originalEducationPost = educationApi.post;

// ===============================================================================================================
// In-flight request tracking (drives the global spinner + long-request UX)
// ===============================================================================================================

let requestCounter = 0;

// requestId -> requestRecord
// requestRecord shape (internal):
// {
//   id, which, method, url, startedAt,
//   controller, budgetTimerId,
//   replay: () => Promise,
// }
const inFlight = new Map();

// Existing processing listeners used by useIsProcessing()
let listeners = new Set();

// New listeners for in-flight request list (used by LongRequestNotifier)
let inFlightListeners = new Set();

function snapshotInFlight() {
  return Array.from(inFlight.values()).map((r) => ({
    id: r.id,
    which: r.which,
    method: r.method,
    url: r.url,
    startedAt: r.startedAt,
    suppressLongRequestWarning: Boolean(r.suppressLongRequestWarning),
  }));
}

function notifyProcessingListeners() {
  const processing = inFlight.size > 0;
  listeners.forEach((listener) => listener(processing));
}

function notifyInFlightListeners() {
  const snap = snapshotInFlight();
  inFlightListeners.forEach((listener) => listener(snap));
}

export function subscribeInFlightRequests(listener) {
  inFlightListeners.add(listener);
  // Emit immediately so UI can sync
  listener(snapshotInFlight());
  return () => {
    inFlightListeners.delete(listener);
  };
}

export function cancelInFlightRequest(requestId) {
  const rec = inFlight.get(requestId);
  if (rec?.controller) {
    try {
      rec.controller.abort();
    } catch (e) {
      // no-op
    }
  }
}

export function retryInFlightRequest(requestId) {
  const rec = inFlight.get(requestId);
  if (!rec?.replay) return;
  // Cancel first (safe even if already completed)
  cancelInFlightRequest(requestId);
  return rec.replay();
}

function linkAbortSignals(parentSignal, childController) {
  if (!parentSignal) return;
  if (parentSignal.aborted) {
    childController.abort();
    return;
  }
  const onAbort = () => childController.abort();
  parentSignal.addEventListener('abort', onAbort, { once: true });
}

function beginTrackedRequest({
  method,
  url,
  which,
  restConfig,
  requestBudgetMs,
  suppressLongRequestWarning,
  replay,
}) {
  const id = ++requestCounter;
  const controller = new AbortController();
  linkAbortSignals(restConfig?.signal, controller);

  // Use our signal (supports Cancel + budget timeout). Any caller-provided signal is linked above.
  const mergedConfig = {
    ...(restConfig || {}),
    signal: controller.signal,
  };

  const startedAt = Date.now();
  // Optional request wall-clock budget (separate from axios.timeout).
  // NOTE: default is "no budget". Callers can opt-in via requestBudgetMs.
  // This avoids surprising CanceledError overlays on slow endpoints.
  let budgetTimerId = null;
  if (typeof requestBudgetMs === 'number' && requestBudgetMs > 0) {
    budgetTimerId = setTimeout(() => {
      // Abort on budget. This will surface as an axios cancellation error.
      try {
        controller.abort();
      } catch (e) {
        // no-op
      }
    }, requestBudgetMs);
  }

  const record = {
    id,
    which,
    method,
    url,
    startedAt,
    controller,
    budgetTimerId,
    suppressLongRequestWarning: Boolean(suppressLongRequestWarning),
    replay,
  };

  inFlight.set(id, record);
  notifyProcessingListeners();
  notifyInFlightListeners();

  return { id, record, mergedConfig };
}

function endTrackedRequest(id) {
  const rec = inFlight.get(id);
  if (rec?.budgetTimerId) {
    clearTimeout(rec.budgetTimerId);
  }
  inFlight.delete(id);
  notifyProcessingListeners();
  notifyInFlightListeners();
}

// Override the get method
const cache = new Map();
hubsupportalApi.get = function (...args) {
  const [url, config = {}] = args;
  // IMPORTANT:
  // - totalRetries is now opt-in (default 0). Prior default (5) could make the global spinner look "stuck".
  // - requestBudgetMs is a max wall-clock budget for a single request (including retries), default 45s.
  const {
    cache_timeout,
    totalRetries = 0,
    requestBudgetMs,
    suppressLongRequestWarning,
    ...restConfig
  } = config;

  const cacheKey = JSON.stringify({ url, config: restConfig });

  if (cache_timeout !== undefined) {
    const cachedItem = cache.get(cacheKey);
    if (cachedItem && (Date.now() - cachedItem.timestamp) < cache_timeout * 1000) {
      console.log('woody', 'Returning cached GET request:', url);
      return Promise.resolve(cachedItem.response);
    }
  }

  console.log('woody', 'Starting GET request:', url);

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  // Prepare a tracked request (supports Cancel + budget)
  const which = 'GET ' + url;
  const tracked = beginTrackedRequest({
    method: 'GET',
    url,
    which,
    restConfig,
    requestBudgetMs,
    suppressLongRequestWarning,
    replay: () => hubsupportalApi.get(url, config),
  });

  const makeRequest = async (retriesLeft, delayMs) => {
    try {
      const response = await originalGet.apply(this, [url, tracked.mergedConfig]);
      console.log('woody', 'Completed GET request:', url);
      endTrackedRequest(tracked.id);

      if (cache_timeout !== undefined) {
        console.log('woody', 'GET result added to cache:', url);
        cache.set(cacheKey, {
          response,
          timestamp: Date.now(),
        });
      }

      return response;
    } catch (error) {
      // Do not retry cancellations/budget aborts
      const isCanceled = axios.isCancel?.(error) || error?.code === 'ERR_CANCELED' || error?.name === 'CanceledError';
      if (!isCanceled && retriesLeft > 0) {
        console.log(
          'woody',
          `Retrying GET request (${totalRetries - retriesLeft + 1}/${totalRetries}):`,
          url
        );
        await delay(delayMs);
        return makeRequest(retriesLeft - 1, Math.min(delayMs + 1000, 8000));
      }

      console.log('woody', 'Error in GET request:', url, error);
      endTrackedRequest(tracked.id);
      throw error;
    }
  };

  return makeRequest(totalRetries, 1000);
};


// Override the post method
hubsupportalApi.post = function (...args) {
  const [url, data, config = {}] = args;
  const { requestBudgetMs, suppressLongRequestWarning, ...restConfig } = config || {};

  console.log('woody', 'Starting POST request:', url);

  const which = 'POST ' + url;
  const tracked = beginTrackedRequest({
    method: 'POST',
    url,
    which,
    restConfig,
    requestBudgetMs,
    suppressLongRequestWarning,
    replay: () => hubsupportalApi.post(url, data, config),
  });

  return originalPost
    .apply(this, [url, data, tracked.mergedConfig])
    .then((response) => {
      console.log('woody', 'Completed POST request:', url);
      endTrackedRequest(tracked.id);
      return response;
    })
    .catch((error) => {
      console.log('woody', 'Error in POST request:', url, error);
      endTrackedRequest(tracked.id);
      throw error;
    });
};

// Override the post method
educationApi.post = function (...args) {
  const [url, data, config = {}] = args;
  const { requestBudgetMs, ...restConfig } = config || {};

  console.log('woody2', 'Starting POST request:', url);

  const which = 'POST ' + url;
  const tracked = beginTrackedRequest({
    method: 'POST',
    url,
    which,
    restConfig,
    requestBudgetMs,
    replay: () => educationApi.post(url, data, config),
  });

  return originalEducationPost
    .apply(this, [url, data, tracked.mergedConfig])
    .then((response) => {
      console.log('woody2', 'Completed POST request:', url);
      endTrackedRequest(tracked.id);
      return response;
    })
    .catch((error) => {
      console.log('woody2', 'Error in POST request:', url, error);
      endTrackedRequest(tracked.id);
      throw error;
    });
};

hubsupportalApi.interceptors.request.use(
  async (config) => {
    console.log("hubsupportalApi.ogre", config.url);
    const access_token = localStorage.getItem("access_token");
    if (access_token) {
      console.log("interceptor::request access_token", access_token);
      config.headers["Authorization"] = `Bearer ${access_token}`;
      config.headers["x-access-token"] = `${access_token}`;
    }
    const refresh_token = localStorage.getItem("refresh_token");
    if (refresh_token) {
      config.headers["x-refresh-token"] = `${refresh_token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const refreshToken = async () => {

  let delayedRetry = false;
  const url = apiUrl("/auth/refresh");
  //const wth = apiUrl("/auth/wth");
  try {
    //const resp = await hubsupportalApi.get("auth/refresh");
    const headers = {
      'x-access-token': localStorage.getItem("access_token"),
      'x-refresh-token': localStorage.getItem("refresh_token")
    }


    //const resp_wth = await axios.get(wth, { withCredentials: true, headers: headers });


    //const resp = await axios.post(url, {}, { withCredentials: true, headers: headers });
    const resp = await axios.get(url, { withCredentials: true, headers: headers });
    console.log("refreshToken", url, resp);
    return resp.data;
  } catch (e) {
    console.log("API Error", url, e);
    if (e.response.status == 401) { // refresh failed
      console.log("login debug 4 - refreshToken - 401 ", url);
      window.location.replace(apiUrl("/auth/login"));
    }
    if (e.response.status == 409) { // refresh in process
      delayedRetry = true;
    }
    if (e.response.status == 410) { // no refresh_token
      console.log("login debug 4 - refreshToken - 410 ", url);
      window.location.replace(apiUrl("/auth/login"));
    }
  }

  if (delayedRetry) {
    try {
      const sleep = ms => new Promise(r => setTimeout(r, ms));
      await sleep(5000)
      const resp = await refreshToken();
      return resp;
    } catch (e) {
    }

  }
};

hubsupportalApi.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error) {

    console.log("interceptor::response error", error);

    const originalRequest = error.config;
    if (error.response) {
      if ((error.response.status === 401 || error.response.status === 403)
        && !originalRequest._retry
        && !originalRequest.url.endsWith("refresh")) {
        try {
          originalRequest._retry = true;

          const resp = await refreshToken();

          localStorage.setItem("access_token", resp.access_token);
          localStorage.setItem("refresh_token", resp.refresh_token);

          hubsupportalApi.defaults.withCredentials = true

          hubsupportalApi.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${resp.access_token}`;
          return hubsupportalApi(originalRequest);
        } catch (e) {
          console.log(e);
          console.log("login debug 5 - interceptor - exception", apiUrl("/auth/login"));
          window.location.replace(apiUrl("/auth/login"));
        }
      }
    }
    return Promise.reject(error);
  }
);

export function allowAction(action, current_hub_type) {

  //console.log("pookie2 : ", current_hub_type);

  // If there is no hub selected, do not allow hub-scoped actions.
  // (Otherwise categories like linux_hub/android_hub could slip through.)
  if (current_hub_type === 'none') {
    return false;
  }

  if (action.category == 'linux_hub') {
    if (current_hub_type == 'android')
      return false;
  } else if (action.category == 'android_hub') {
    if (current_hub_type == 'linux')
      return false;
  } else if (action.category == 'any_hub') {
  } else {
    return false;
  }

  return true;

}

export function format_milliseconds(milliseconds) {
  try {
    var total_hours = parseInt(milliseconds) / 1000 / 60 / 60;
    var days = Math.floor(total_hours / 24);
    var hours = Math.floor(total_hours - (24 * days));
    var minutes = (total_hours - (24 * days) - hours) * 60;
    var res = "";
    if (days == 1) {
      res = res + days.toFixed(0) + " day ";
    } else if (days > 0) {
      res = res + days.toFixed(0) + " days ";
    }
    if (hours == 1) {
      res = res + hours.toFixed(0) + " hour ";
    } else if (hours > 0) {
      res = res + hours.toFixed(0) + " hours ";
    }
    if (minutes == 1) {
      res = res + minutes.toFixed(1) + " minute ";
    } else if (minutes > 0) {
      res = res + minutes.toFixed(1) + " minutes ";
    }
    return res;
    /*
    if ( days == 0 ) {
        return hours.toFixed(1) + " hours"; 
    } else {
        return days.toFixed(0) + " days " + hours.toFixed(0) + " hours"; 
    }
    */
  } catch (e) {

  }

  return String(milliseconds);
}

/*
let activeRequests = 0;
let timeoutIds = new Set();

export function startRequest() {
  activeRequests++;
  const timeoutId = setTimeout(() => {
    console.warn('Request timed out');
    endRequest();
  }, 30000);
  timeoutIds.add(timeoutId);
  return timeoutId;
}

export function endRequest(timeoutId) {
  if (timeoutId) {
    clearTimeout(timeoutId);
    timeoutIds.delete(timeoutId);
  }
  activeRequests = Math.max(0, activeRequests - 1);
}
*/

// Legacy processing indicator API (used by Layout1Topbar.jsx)
// We keep the same exports, but the internal counter is now based on the inFlight map.
export function startRequest(which) {
  // startRequest/endRequest are no longer used by hubsupportalApi.get/post overrides.
  // Kept for backwards compatibility if anything else calls them.
  const id = ++requestCounter;
  inFlight.set(id, {
    id,
    which,
    method: which.split(' ')[0],
    url: which.substring(which.indexOf(' ') + 1),
    startedAt: Date.now(),
    controller: null,
    budgetTimerId: null,
    replay: null,
  });
  notifyProcessingListeners();
  notifyInFlightListeners();
  return id;
}

export function endRequest(timeoutId, which) {
  // Remove the legacy record if present.
  endTrackedRequest(timeoutId);
}

export function useIsProcessing() {
  const [isProcessing, setIsProcessing] = useState(inFlight.size > 0);

  useEffect(() => {
    const listener = (processing) => {
      setIsProcessing(processing);
    };

    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  }, []);

  return isProcessing;
}

export const useRefreshOnProcessingChange = (callback) => {
  const isProcessing = useIsProcessing();

  useEffect(() => {
    if (!isProcessing) {
      callback();
    }
  }, [isProcessing, callback]);
};
